export default "__VITE_ASSET__DlQo6p4H__"